module.exports = __webpack_public_path__ + "img/ym.e21ec277.png";